module.exports = __webpack_public_path__ + "img/mem_coupon_font1.c1cda1d4.jpg";